import { render, staticRenderFns } from "./ResultTopicUserInfo.vue?vue&type=template&id=d1298134&scoped=true"
import script from "./ResultTopicUserInfo.vue?vue&type=script&lang=js"
export * from "./ResultTopicUserInfo.vue?vue&type=script&lang=js"
import style0 from "./ResultTopicUserInfo.vue?vue&type=style&index=0&id=d1298134&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1298134",
  null
  
)

export default component.exports